import { render, staticRenderFns } from "./ASC_ByReason.vue?vue&type=template&id=a1cc3188&scoped=true&"
import script from "./ASC_ByReason.vue?vue&type=script&lang=js&"
export * from "./ASC_ByReason.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1cc3188",
  null
  
)

export default component.exports